import { render, staticRenderFns } from "./WizardEtapas.vue?vue&type=template&id=725c2650&scoped=true"
import script from "./WizardEtapas.vue?vue&type=script&lang=js"
export * from "./WizardEtapas.vue?vue&type=script&lang=js"
import style0 from "./WizardEtapas.vue?vue&type=style&index=0&id=725c2650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c2650",
  null
  
)

export default component.exports